import z from 'zod'

export const zColor = z.object({
  r: z.int().min(0).max(255),
  g: z.int().min(0).max(255),
  b: z.int().min(0).max(255),
  a: z.int().min(0).max(255),
  index: z.int().optional(),
})

/** All color values are in range [0,255] */
export type Color = z.infer<typeof zColor>
